module.exports = require('integration/billing/bc3/services/GatewayPaymentMethodService')